export default __webpack_public_path__ + "static/media/PLCImg.d386ae82.jpg";